export default "__VITE_ASSET__CQawk_xw__"